export const calculateMonetaryNeed = (
  income: number,
  need: number,
  duration: number,
  inflation: number,
): number => (
  (need <= 0 || income <= 0) ? 0 : income * (((inflation / 100) + 1) ** duration) * (need / 100)
);
